/**
 * Created by JIocb on 2/3/2016.
 */
module Factive.Core {
    "use strict"
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import Signal = Factive.Core.Signal.Signal;

    export class PanelManager {
        private _aspectRatio: string;
        private _classByKey: any;
        private _panelInstacesStorage: any;
        private _activePanels: Array<Panel>;

        private _panelContainer: PIXI.Container;
        private _dc: Factive.Core.DependenciesContainer;
        private _scrim: PIXI.extras.TilingSprite;
        //private _scrimSetttings: PIXI.extras.TilingSprite;

        constructor(dc: DependenciesContainer) {
            this._dc = dc;
            this._classByKey = {};
            this._panelInstacesStorage = {};
            this._activePanels = [];
        };

        public initialize(panelContainer: PIXI.Container,  aspectRatio: string) {
            this._panelContainer = panelContainer;
            this._aspectRatio = aspectRatio;
            this.drawScrim();

        };
        private drawScrim():void
        {
            var SCRIM_TILE_BASE_64:string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAALiIAAC4iAari3ZIAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAAaUlEQVRYR83IMQEAMAzAoJqbhLqvmBmIAA4eZt4eLVOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTMbeB/FBIgj+ztOMAAAAAElFTkSuQmCC";
            var tile = PIXI.Texture.fromImage(SCRIM_TILE_BASE_64);
            this._scrim = new PIXI.extras.TilingSprite(
                tile,
                400,
                400
            );
            this._scrim.anchor.set(.5,.5);
            this._scrim.interactive = true;
            this._panelContainer.addChild(this._scrim);
            this._scrim.visible = false;
            //
            // var SCRIM_SETTINGS_TILE_BASE_64:string = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAALiIAAC4iAari3ZIAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAAaElEQVRYR83IMQEAMAzAoKqt+JnoDEQABw8z75aWKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEmmJFOSKcmUZEoyJZmSTEkm4/YDMPVukxmMQz8AAAAASUVORK5CYII=";
            // var tileSetttings = PIXI.Texture.fromImage(SCRIM_SETTINGS_TILE_BASE_64);
            // this._scrimSetttings = new PIXI.extras.TilingSprite(
            //     tileSetttings,
            //     400,
            //     400
            // );
            // this._scrimSetttings.anchor.set(.5,.5);
            // this._scrimSetttings.interactive = true;
            // this._panelContainer.addChild(this._scrimSetttings);
            // this._scrimSetttings.visible = false;
        }

        public registerPanel(panelName, panelClass)
        {
            this._classByKey[panelName] = panelClass;
        };

        public open(panelName, data)
        {

            let panel = <Panel>this._panelInstacesStorage[panelName];

            if (panel)
            {
                panel.reset();
                this._panelContainer.addChild(panel);
                panel.initialize(this._aspectRatio, data);
                panel.open();
                this._panelInstacesStorage[panelName] = panel;

                var index:number = this.getPanelIndexInActivePanelList(panel);
                if(index == -1) {
                    this._activePanels[this._activePanels.length] = panel;
                }

                this._scrim.alpha = panel.scrimAlpha;
                this._scrim.visible = panel.scrimVisible;
                //this._scrimSetttings.visible = panel.scrimSetttings;

                return panel;
            }

            var cl = this._classByKey[panelName];
            panel = new cl(this._dc,panelName);
            this._panelContainer.addChild(panel);
            panel.initialize(this._aspectRatio, data);
            panel.open();

            this._panelInstacesStorage[panelName] = panel;
            this._activePanels[this._activePanels.length] = panel;

            this._scrim.alpha = panel.scrimAlpha;
            this._scrim.visible = panel.scrimVisible;
            //this._scrimSetttings.visible = panel.scrimSetttings;

            return panel;
        };

        public close(panelName) {

            var panel = this._panelInstacesStorage[panelName];

            if (panel) {
                panel.signal.add(this.onPanelEvent, this);
                panel.hide();
            }

            return panel;
        };

        public resize(w:number,h:number,aspectRatio:string)
        {
            this._scrim.width = w/this._panelContainer.scale.x;
            this._scrim.height = h/this._panelContainer.scale.y;

            // this._scrimSetttings.width = w/this._panelContainer.scale.x;
            // this._scrimSetttings.height = h/this._panelContainer.scale.y;


            if(this._aspectRatio != aspectRatio){
                this.aspectRatio(aspectRatio);
            }
        }

        public aspectRatio(aspectRatio:string) {
            this._aspectRatio = aspectRatio;

            for (var key in this._panelInstacesStorage) {
                if (this._panelInstacesStorage.hasOwnProperty(key)) {
                    var panel = <Panel>this._panelInstacesStorage[key];

                    if (panel != null && (panel.parent != null || panel.parent != undefined )) {
                        panel.resize(this._aspectRatio);
                        this._scrim.alpha = panel.scrimVisible ? 1 : 0;
                    }
                }
            }

        };


        public onPanelEvent(panel, eventname) {
            if (eventname === 'hided')
            {
                var index:number = this.getPanelIndexInActivePanelList(panel);
                if(index != -1)
                {
                    this._activePanels.splice(index,1);
                }

                this._scrim.visible = this._activePanels.length > 0;
                panel.reset();
                panel.parent.removeChild(panel);
            }
        };

        private getPanelIndexInActivePanelList(panel:Panel):number
        {
            var l:number = this._activePanels.length;
            for(var i:number = 0; i<l; i++)
            {
                if(this._activePanels[i].panelName == panel.panelName )
                {
                    return i;
                }
            }

            return -1;
        }


        public destroy() {
            "use strict";
            for (var key in this._panelInstacesStorage) {
                if (this._panelInstacesStorage.hasOwnProperty(key)) {
                    var panel = this._panelInstacesStorage[key];

                    if (panel != null && panel.parent) {
                        panel.destroy();
                        panel.parent.removeChild(panel)
                    }
                }
            }

            this._aspectRatio = null;
            this._classByKey = null;
            this._panelInstacesStorage = null;
            this._activePanels = null;
            this._panelContainer = null;
        };

    }
}



// WEBPACK FOOTER //
// src/typescript/Core/Panel/PanelManager.ts